import React from 'react';

interface OdxTableRowProps {
    children: React.ReactNode,
    onClick?: () => void,
    className?: string,
    id?: string,
    key?: string
}

/**
 * @param children
 * @param onClick
 */

export const OdxTableRow: React.FC<OdxTableRowProps> = ({children, onClick, className, id, key}) => {
    return (
        <tr
            className={`odx-table__row ${className}`}
            onClick={onClick} id={"OdxTableRow_" + id}>
            {children}
        </tr>
    );
};

